import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import { Toaster } from '../ui/sonner';

const MainLayout = () => {
    const { isAuthenticated, loading, user, isAtendente } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen bg-black flex items-center justify-center">
                <div className="w-12 h-12 border-4 border-red-500 border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/acesso" replace />;
    }

    // Atendente só pode acessar PDV e Caixa
    if (isAtendente()) {
        const allowedPaths = ['/admin/pdv', '/admin/caixa'];
        const currentPath = location.pathname;
        
        if (!allowedPaths.some(path => currentPath.startsWith(path))) {
            return <Navigate to="/admin/pdv" replace />;
        }
    }

    return (
        <div className="min-h-screen bg-black">
            <div className="noise-overlay" />
            <Sidebar />
            {/* Main content: padding-top for mobile header, margin-left for desktop sidebar */}
            <main className="pt-16 lg:pt-0 lg:ml-64 min-h-screen">
                <div className="p-4 sm:p-6 lg:p-8">
                    <Outlet />
                </div>
            </main>
            <Toaster position="top-right" />
        </div>
    );
};

export default MainLayout;
